// mixpanel.ts
import mixpanel, { Config, Dict } from 'mixpanel-browser';

// Define custom types for your application
export interface UserProperties {
    $email?: string;
    $name?: string;
    [key: string]: any;
}

export interface EventProperties extends Dict {
    [key: string]: any;
}

const IS_DEV =
    window.location.hostname.includes('localhost') || window.location.hostname.includes('dev');
const IS_STAGE = window.location.hostname.includes('stage');

// Your Mixpanel project token
const MIXPANEL_TOKEN =
    IS_DEV || IS_STAGE ? '6b932490eab0c2d82f3d121e54afd119' : '5ddd451470050d92cffe8e2339763ef3';

// Configuration options
const config: Partial<Config> = {
    debug: true,
    persistence: 'localStorage',
    autocapture: false,
    api_host: 'https://api.mixpanel.com',
};

// Initialize Mixpanel
mixpanel.init(MIXPANEL_TOKEN, config);

// Simplified type-safe Mixpanel service
const MixpanelService = {
    // Identify a user
    identify(userId: string): void {
        mixpanel.identify(userId);
    },

    // Track an event
    track(eventName: string, properties?: EventProperties): void {
        mixpanel.track(eventName, properties);
    },

    // Set user properties
    setUserProperties(properties: UserProperties): void {
        mixpanel.people.set(properties);
    },

    // Time tracking - start timing an event
    timeEvent(eventName: string): void {
        mixpanel.time_event(eventName);
    },
};

// Export singleton instance
export default MixpanelService;
